<template>
  <div>
    <ba-header activeModule="Enrollment Invitations"></ba-header>
    <div class="u-p4 main-content">
      <h2 class="c-heading__page u-mt4 u-pt2">Enrollment Invitations</h2>
      <div>
        <div class="u-mt3">
          <div class="u-mt4">
            <el-form inline>
              <el-form-item label="From" class="line-height-3"><el-date-picker v-model="range.from" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="range.to" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item><el-button @click="loadPage(1)" icon="el-icon-search">Filter</el-button></el-form-item>
              <el-button v-if="range.from !== '' || range.to !== ''" @click="clearFilter">Clear Filter</el-button>
            </el-form>
          </div>

          <el-button v-if="isSuperUser"
                     @click="onRemoveInvitationsClick()"
                     :disabled="!areButtonsEnabled"
                     icon="el-icon-check">Remove Invitations</el-button>
          <el-table v-loading="loading"
                    class="u-mt3 invitations-table"
                    :data="items"
                    @selection-change="onSelectionChange"
                    :row-class-name="invitationsTableRowClassName"
                    style="width: 100%">
            <el-table-column v-if="isSuperUser" type="selection" width="50"></el-table-column>
            <el-table-column prop="name" label="Name"></el-table-column>
            <el-table-column prop="email" label="Email Address"></el-table-column>
            <el-table-column prop="contact_id" label="Contact Id" width="300"></el-table-column>
            <el-table-column prop="status" label="Invitation Status" width="200"></el-table-column>
            <el-table-column label="Invitation Date/Time" width="200">
              <template slot-scope="scope">
                {{ fixedTimestamp(scope.row.invite_time) }}
              </template>
            </el-table-column>

            <el-table-column prop="email_status" label="Email Status" width="150"></el-table-column>
          </el-table>
          <el-pagination class="u-mt4" layout="prev, pager, next"
                         :total="total" :page-size="perPage"
                         :current-page="page" @current-change="loadPage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import BaCompanyImage from '@/modules/appearance/company-image.component'
import ElButton from 'element-ui/packages/button/src/button'
import axios from 'axios'
import config from '@/config'
import _ from 'lodash'
import * as moment from 'moment'

export default {
  components: {
    ElButton,
    BaCompanyImage,
  },
  name: 'EnrollmentInvitations',
  data () {
    return {
      companyId: this.$route.params.companyId,
      range: {
        from: '',
        to: '',
      },
      items: [],
      selectedItems: [],
      loading: true,
      total: 0,
      page: 1,
      perPage: 20,
    }
  },
  computed: {
    ...mapState('shared', ['user']),
    areButtonsEnabled () {
      return !this.loading && this.selectedItems.length > 0
    },
    isSuperUser () {
      return ((this.user !== undefined) && (this.user !== null)) ? this.user.is_superuser : false
    },
  },
  beforeMount () {
    this.loading = true
    this.loadInitial()
  },
  methods: {
    invitationsTableRowClassName ({row, rowIndex}) {
      let status = row.status
      let matchDict = {
        TBD: 'tbd-row-invitations-table',
        RECEIVED: 'received-row-invitations-table',
        INVITE_SEND_PENDING: 'invite-send-pending-row-invitations-table',
        INVITE_SENT_OK: 'invite-send-ok-row-invitations-table',
        INVITE_SENT_ERROR: 'invite-sent-error-row-invitations-table',
        ACCEPTED: 'accepted-row-invitations-table',
        EXPIRED: 'expired-row-invitations-table',
        BYPASSED: 'bypassed-row-invitations-table',
      }
      return matchDict[status] || ''
    },
    onSelectionChange (selectedItems) {
      this.selectedItems = selectedItems
    },
    async onRemoveInvitationsClick () {
      let entToDelete = []
      this.selectedItems.forEach((item) => {
        entToDelete.push(`${item.name}: ${item.email}`)
      })
      try {
        await this.$confirm(
          `This will delete from Invitations:\n ${entToDelete.join('\n')}. Continue?`,
          'Invitations are about to be deleted', {
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            type: 'info',
            dangerouslyUseHTMLString: true
          }
        )
      } catch (e) {
        // user cancel
        this.$message({
          type: 'info',
          message: 'Operation canceled'
        })
        return
      }

      this.removeInvitations(this.selectedItems)
    },
    idsFromItems (selectedItems) {
      return _.map(selectedItems, function (item) {
        return item['id']
      })
    },
    async removeInvitations (selectedItems) {
      let ids = this.idsFromItems(selectedItems)
      this.loading = true
      try {
        await axios.delete(`${config.url}/company/${this.companyId}/enrollment-invitations/`, {data: {ids}})
      } catch (e) {
        console.warn(e)
        this.$message({
          type: 'error',
          message: 'Failed to perform action.'
        })
      }

      this.loadPage(1)
    },
    loadInitial () {
      this.loadPage(1)
    },
    clearFilter () {
      this.range.from = ''
      this.range.to = ''
      return this.loadPage(1)
    },
    fixedTimestamp (timestamp) {
      return moment(new Date(timestamp)).format('MM/DD/YYYY hh:mm:ss A')
    },
    loadPage (page) {
      console.log('loadPage')
      this.loading = true

      let params = {
        page_size: this.perPage,
        page: page,
      }

      if (this.range.from !== '') params.from_date = this.$moment(this.range.from).format('MM-DD-YYYY')
      if (this.range.to !== '') params.to_date = this.$moment(this.range.to).format('MM-DD-YYYY')

      axios.get(`${config.url}/company/${this.companyId}/enrollment-invitations/`, {params: params})
        .then((ret) => {
          let res = ret.data.data
          this.items = res.items
          this.total = res.total
          this.perPage = res.page_size
          this.page = res.page
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
  .line-height-3 {
    line-height: 2em;
  }


</style>

<style>
/* we must use global styles for element.io components */
  .tbd-row-invitations-table {
    background-color: #f0f0f0 !important;
  }

  .received-row-invitations-table {
    background-color: cyan !important;
  }

  .invite-send-pending-row-invitations-table {
    background-color: oldlace !important;
  }

  .invite-send-ok-row-invitations-table {
    background-color: yellow !important;
  }

  .invite-sent-error-row-invitations-table {
    background-color: #ff00005c !important;
  }

  .accepted-row-invitations-table {
    background-color: lightgreen !important;
  }

  .expired-row-invitations-table {
    background-color: darkgrey !important;
  }

  .bypassed-row-invitations-table {
    background-color: greenyellow !important;
  }
</style>
